/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { SwimmingLaneProps, SwimmingLaneRef } from "./types";

export default CustomPlatform.select<
  () => React.ForwardRefExoticComponent<
    SwimmingLaneProps & React.RefAttributes<SwimmingLaneRef>
  >
>({
  tv: () => require("./SwimmingLane.tv").default,
  web: () => require("./SwimmingLane.web").default,
  native: () => require("./SwimmingLane").default,
})();
